import React, { useEffect, useState } from "react";
import { getDeliveryHistory } from "../api/deliveryService";

const DeliveryHistoryPage = () => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const data = await getDeliveryHistory();
                setHistory(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("Failed to load delivery history:", error);
                setError("Failed to load delivery history.");
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, []);

    if (loading) return <p>Loading delivery history...</p>;
    if (error) return <p className="text-red-500">{error}</p>;

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4">Delivery History</h2>

            {history.length === 0 ? (
                <p>No delivery history found.</p>
            ) : (
                <ul>
                    {history.map((h) => (
                        <li key={h.id} className="mb-2 border p-2 rounded">
                            <p>
                                <strong>Order date:</strong>{" "}
                                {h.orderDate
                                    ? new Date(h.orderDate).toLocaleDateString()
                                    : "�"}
                            </p>

                            <p>
                                <strong>Actual cost:</strong>{" "}
                                {h.actualCost ?? "�"} EUR
                            </p>

                            <p>
                                <strong>Distance:</strong>{" "}
                                {h.actualDistanceInKm ?? "�"} km
                            </p>

                            <p>
                                <strong>Remarks:</strong>{" "}
                                {h.remarks || "�"}
                            </p>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default DeliveryHistoryPage;